import { Button, Popconfirm, TableProps, Tag } from "antd";
import { IMultiLanguage } from "../../types/MutliLanguage";
import TitlePopOver from "./Components/TitlePopover";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { TbImageInPicture } from "react-icons/tb";
import { CiTrash } from "react-icons/ci";
export interface ArticleTableDataType {
  id: string;
  title: IMultiLanguage;
  image: string;
  content: IMultiLanguage;
  keywords: IMultiLanguage[];
}

export const ArticleColumns = (
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<ArticleTableDataType>["columns"] => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        <TitlePopOver value={record.title} />
        <Link
          to={`/articles/edit-title/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },
  {
    title: "Keywords",
    dataIndex: "keywords",
    key: "keywords",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        {record.keywords.map((key: IMultiLanguage) => (
          <Tag
            title={`${key.Ar} - ${key.Fr}`}
            className="flex justify-center items-center"
            color="blue"
          >
            {key.En}
          </Tag>
        ))}
        <Link
          to={`/articles/edit-keywords/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },

  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/articles/edit/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Link
          to={`/articles/edit-image/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<TbImageInPicture />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this article?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];
